import {Controller} from "@hotwired/stimulus"

// Connects to data-controller="sign-in"
export default class extends Controller {

    static targets = ['button']

    connect() {
        this.buttonTarget.click()
    }


}